import Vue from 'vue'
Vue.filter('money', function (value) {
	value = parseInt(value)
  return "$. " + value.toFixed(2).toString().replace(/\./g,',').replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g, "$1\.")
})
